<template>
    <div class="col flex-1">
        <div class="col c-items p-20">                        
            <div class="card">
                <div class="card-top">
                    <div class="card-icon">
                        <img src="../../assets/images/icon-follow.png"/>
                    </div>
                    <span class="text-white ts-l text-bold">General</span>
                </div>
                <!-- <img class="card-avatar" src="../../assets/bg-demo.jpeg"/> -->
                <VueperSlides fade :touchable="false">
                    <VueperSlide
                        v-for="(slide, i) in memory.images"
                        :key="i"
                        :image="slide"/>
                </VueperSlides>
                <div class="card-content-container">
                    <div class="card-title">
                        <p>{{memory.title}}</p>
                        <div class="card-title-line"></div>
                    </div>
                    <div class="row c-items">
                        <span class="ts-l text-grey">{{memory.date === null ? "--" : moment(memory.date).format('MMMM DD, YYYY') }}</span>
                        <div class="flex-1"></div>
                        <div v-if="memory.is_space === 1" class="memo-type">
                            <img src="../../assets/images/icon-space.png"/>
                        </div>
                        <div v-if="memory.is_safe === 1" class="memo-type">
                            <img src="../../assets/images/icon_save_to_safe_box.png"/>
                        </div>
                        <div v-if="memory.is_ghost === 1" class="memo-type">
                            <img src="../../assets/images/icon_ghost_black.png"/>
                        </div>
                    </div>
                    <p class="ts-m tj">{{memory.text}}</p>
                    <div class="row">
                        <div v-for="(audio, i) in memory.audios" :key="i"  
                            class="memo-sound"
                            @click="playAudio(i)">
                            <img src="../../assets/images/sound.png"/>
                            <img v-if="(playingIndex === i)" class="btn-audio" src="../../assets/images/icon_pause.svg"/>
                            <img v-else class="btn-audio" src="../../assets/images/icon_play.svg"/>
                        </div>                        
                    </div>
                </div>
            </div>            
        </div>        
    </div>
</template>
 
<style scoped>
.btn-audio {
    position: absolute;
    width: 25px;
    background-color: white;
}
</style>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import moment from 'moment'
import DibbleTranslation from "../../translation/translation"
import DibbleAPI from '../../api';
import 'vueperslides/dist/vueperslides.css'
import DibbleJS from '../../dibble'

export default {
    name: "MemoDetailsPage",
    components: {
        VueperSlides, 
        VueperSlide,
    },
    props: {
        msg: String
    },
    data () {
        return {
            showDialog: false,
            audioObj : new Audio(""),
            playingIndex: -1,
            audioPlaying: false,
            senderName: "",
            email: "",
            password: "",            
            translate: DibbleTranslation,
            demoContent: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam",
            comment: "",
            shareToken: "",            
            isForComment: false,
            deletedCommentId: "",
            memory: {
                memory_id : "",
                user_id: "",
                title: "",
                year: 1980,
                date: "",
                is_reccur: 0,
                text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam",
                images: [],
                audios: [],
                bkg_color: "",
                folder_id: 0,
                is_space: 0,
                is_safe: 0,
                views: 0,
                is_ghost: 0
            }            
        }
    },
    mounted: function () {
        const self = this;    
        console.log(self)
        const data = this.$route.params;
        if (data.memo_id != null && data.memo_id !== "") {
            loadMemory(self, data.memo_id)
        }        
    },
    methods : {
        moment: function (date) {
            return moment(date)
        },
        playAudio: function (audioIndex) {         
            if (audioIndex === this.playingIndex) {
                this.playingIndex = -1
                // this.audioObj.pause()
            } else {
                this.playingIndex = audioIndex                
            }
            if (this.memory.audios.length > audioIndex) {
                if (this.audioObj !== undefined) {
                    if (this.audioObj.src === this.memory.audios[audioIndex]) {
                        if (this.audioPlaying) {
                            this.audioObj.pause()
                            this.audioPlaying = false
                        } else {
                            this.audioObj.play()
                            this.audioPlaying = true
                        }
                    } else {
                        this.audioObj.pause()
                        this.audioObj = new Audio(this.memory.audios[audioIndex]);
                        this.audioObj.play();
                        this.audioPlaying = true
                    }
                } else {
                    this.audioObj = new Audio(this.memory.audios[audioIndex]);
                    this.audioObj.play();
                }                    
            } else {                
                DibbleJS.toastErrorMessage("Error in playing sound")
            }            
        },        
    }
}

const loadMemory = async function (self, memoId) {
    const data = {
        "#request" : DibbleAPI.api.memory.get,
        // "#token": Helper.getUserToken(),
        memory_id: memoId
    }
    DibbleJS.showLoader()
    DibbleJS.callApiRequest(
        data, 
        (responseData) => {            
            DibbleJS.hideLoader();
            if (DibbleAPI.isResponseSuccess(responseData)) {
                self.memory = responseData                        
            } else {
                DibbleJS.toastErrorMessage(responseData.message);
                self.$router.back();                
            }
        },
        true
    )
}
</script>